import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject, ProviderToken } from '@angular/core';
import { IdSettable } from '@stores/models';

export const StoreObjectGuard = (action: 'enter' | 'leave', storeClass: ProviderToken<IdSettable>, paramName: string) => {
    if (action === 'enter') {

        return (
            route: ActivatedRouteSnapshot,
            state: RouterStateSnapshot,
        ) => {

            const store = inject(storeClass);
            const id = route.paramMap.get(paramName)!;

            store.setId(id);

            return true;
        };


    } else {
        return (
            component: any,
            currentRoute: ActivatedRouteSnapshot,
            currentState: RouterStateSnapshot,
            nextState: RouterStateSnapshot,
        ) => {

            const store = inject(storeClass);
            store.setId(null);

            return true;
        };
    }
}
